'use client';

import { AccordionItem, AccordionTrigger, Root } from '@radix-ui/react-accordion';

import ChevronDown from '../../icons/directions/ChevronDown';
import { Typography } from '../typography/Typography';
import { AccordionContent } from './AccordionContent';

export interface AccordionProps {
  /** Title of the accordion **/
  title: string;
  /** Content of the accordion **/
  children: React.ReactNode | string;
  /** Value of the used by the radix-ui elements **/
  value: string;
  /** Standalone - boolean to indicate if we have to add the Radix-ui Root element  **/
  standalone?: boolean;
  /** Optional className for the trigger element **/
  triggerClassName?: string;
  testid?: string;
}

export function Accordion(props: AccordionProps) {
  const {
    standalone,
    children,
    ...accordionProps
  } = props;

  if (!standalone) {
    return (
      <AccordionElement {...accordionProps}>
        {children}
      </AccordionElement>
    );
  }

  return (
    <Root
      type="single"
      collapsible
    >
      <AccordionElement {...accordionProps}>
        {children}
      </AccordionElement>
    </Root>
  );
}

function AccordionElement(props: Omit<AccordionProps, 'standalone'>) {
  return (
    <AccordionItem
      value={props.value}
      className="w-full border-b border-divider first:border-t"
      data-testid={props.testid}
    >
      <AccordionTrigger
        className={`group/accordion-trigger flex w-full justify-between py-4 text-left text-base-primary-on-light hover:text-link-enabled-on-light hover:underline ${props.triggerClassName ?? ''}`}
      >
        <Typography
          variant="label-regular"
          type="span"
        >
          {props.title}
        </Typography>
        <ChevronDown
          aria-hidden="true"
          className="ml-auto size-[22px] shrink-0 text-icon-link transition-transform duration-300 group-data-[state=open]/accordion-trigger:rotate-180"
        />
      </AccordionTrigger>
      <AccordionContent>
        <div className="pb-4 pl-0 pr-10 pt-0">
          {props.children}
        </div>
      </AccordionContent>
    </AccordionItem>
  );
}
